import { ColumnProps, RowKey } from './types';

export const Column = <T, K extends RowKey = RowKey>(
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  props: ColumnProps<T, K>
) => {
  return null;
};
